export * from './useSmartRedirect'
